import {
  usersDataRequest,
  usersDataSuccess,
  usersDataFailure,
} from '.';
import { AdminService } from '../../services/requests';
import {
  APPLICANT,
  RECRUITER,
  FREELANCER,
  REPRESENTATIVE,
} from '../../services/roles';

const UsersHelper = {
  getAllUsers: () => async (dispatch) => {
    dispatch(usersDataRequest());
    const applicantSavedData = JSON.parse(sessionStorage.getItem('applicants'));
    const recruiterSavedData = JSON.parse(sessionStorage.getItem('recruiters'));
    const freelancerSavedData = JSON.parse(sessionStorage.getItem('freelancers'));
    const representativeSavedData = JSON.parse(sessionStorage.getItem('representatives'));

    try {
      const applicant = await AdminService.getUsersList(APPLICANT, 1, applicantSavedData?.direction || 'desc', applicantSavedData?.category || '');
      const recruiter = await AdminService.getUsersList(RECRUITER, 1, recruiterSavedData?.direction || 'desc', recruiterSavedData?.category || '');
      const freelancer = await AdminService.getUsersList(FREELANCER, 1, freelancerSavedData?.direction || 'desc', freelancerSavedData?.category || '');
      const representative = await AdminService.getUsersList(REPRESENTATIVE, 1, representativeSavedData?.direction || 'desc', representativeSavedData?.category || '');

      if (applicant && recruiter && freelancer && representative) {
        dispatch(usersDataSuccess({
          applicants: {
            last: applicant.last,
            data: applicant.data,
          },
          recruiters: {
            last: recruiter.last,
            data: recruiter.data,
          },
          freelancers: {
            last: freelancer.last,
            data: freelancer.data,
          },
          representatives: {
            last: representative.last,
            data: representative.data,
          },
        }));
      }
    } catch (err) {
      dispatch(usersDataFailure(err));
    }
  },
};

export default UsersHelper;
